module.exports = __webpack_public_path__ + "static/partner_reluis_new-07d8935d05913c49efd1a7fc3fa2f6e7.svg";